"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStore = exports.Themes = exports.SCSWEEET = exports.SMITH = exports.RICO = exports.CODA = void 0;
var mobx_1 = require("mobx");
var config_1 = __importDefault(require("config"));
var Store_1 = require("./Store");
exports.CODA = 'coda';
exports.RICO = 'ricoplastics';
exports.SMITH = 'smithfield';
exports.SCSWEEET = 'scsweettreats';
var Themes;
(function (Themes) {
    Themes[Themes["DARK"] = 0] = "DARK";
    Themes[Themes["LIGHT"] = 1] = "LIGHT";
})(Themes = exports.Themes || (exports.Themes = {}));
var storageKeys = config_1.default.storageKeys, userRoles = config_1.default.userRoles;
var UserStore = /** @class */ (function (_super) {
    __extends(UserStore, _super);
    function UserStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            if (localStorage.getItem(storageKeys.USER) === null)
                localStorage.setItem(storageKeys.USER, JSON.stringify({ id: data.id }));
            _this.data = data;
        };
        _this.unsetData = function () {
            localStorage.removeItem(storageKeys.USER);
            _this.data = null;
        };
        return _this;
    }
    Object.defineProperty(UserStore.prototype, "isAdmin", {
        get: function () {
            return this.data.roles.contains(userRoles.ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "isSuperAdmin", {
        get: function () {
            return this.data.roles.contains(userRoles.SUPER_ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], UserStore.prototype, "isAdmin", null);
    __decorate([
        mobx_1.computed
    ], UserStore.prototype, "isSuperAdmin", null);
    return UserStore;
}(Store_1.Store));
exports.UserStore = UserStore;
var userStore = new UserStore(null);
exports.default = userStore;
